import { HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { adminManageHospitalListHeader, adminManageHospitalWidth } from 'constants/pagination';
import { getWidthRation } from 'utils/calculateWdith';
import { AdminManageHospitalPaginationProps } from 'models/Admin/AdminPaginationTypes';
import { NothingDataInManagingPatientsPagination } from 'pages/Admin/DCK/AddDiagnosisPage/NothingDataInPagination';
import CustomedPagination from 'components/Pagination/CustomedPagination';
import AdminManageHospitalPaginationTable from './AdminManageHospitalPaginationTable';

const AdminManageHospitalPagination = ({
    currentPage,
    totalPages,
    pageGroup,
    handlePageGroup,
    handlePageChange,
    currentData,
    initNumber,
    totalCount,
    handleResetButton,
    onHospitalSelect,
}: AdminManageHospitalPaginationProps) => {
    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper>
                    {adminManageHospitalListHeader.map((name, idx) => {
                        return (
                            <TableCell key={idx} $width={getWidthRation(adminManageHospitalWidth[idx])} $type='header' $justifyContent='space-between' cellType={name.type}>
                                {name.title}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {currentData?.length !== 0 ? (
                    <AdminManageHospitalPaginationTable currentPage={currentPage} totalCount={totalCount} currentData={currentData} onHospitalSelect={onHospitalSelect} />
                ) : (
                    <NothingDataInManagingPatientsPagination initNumber={initNumber} handleResetButton={handleResetButton} />
                )}
            </TableLayout>
            {currentData && totalPages !== 0 && (
                <CustomedPagination currentPage={currentPage} onChangeCurrentPage={handlePageChange} onChangeSectionIdx={handlePageGroup} sectionIndex={pageGroup} totalPages={totalPages} />
            )}
        </Layout>
    );
};

export default AdminManageHospitalPagination;
